import { useSelector, type TypedUseSelectorHook } from 'react-redux';
import { type RootState } from '../../stores/redux';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
